import t from "./index983.js";
function e() {
  this.__data__ = t ? t(null) : {}, this.size = 0;
}
export {
  e as default
};
